module.exports = __webpack_public_path__ + "img/support_hand@2x.d73ac900.png";